import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import {
  authHeader,
  loggedUserDetails,
} from '../../utils/functions/CoreFunctions';
import { AGENCY_DETAILS_URL,AGENCY_UPDATE} from '../../utils/APIEndpoints';
import API from '../../redux/actions/API';
import {
  getAlertToast,
  getDateString,
} from '../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import CustomLoader from '../common/CustomLoader';
import defaultAvatar from '../../assets/images/defaultImages/defaultAvatar.png';
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import Switch from 'react-switch';

const AgencyProfile = (props) => {
  //const {locationCodeFromResponse} = props
  const { agencyId: loggedAgency = '', role = '' } = loggedUserDetails();
  const [agencyData, setAgencyData] = useState({});
  const [loading, setLoading] = useState(false);
  const [checked,setChecked] = useState();
  const [locationCodeData, setLocationCodeData] = useState(null);

  //Get Agency Data
  const getAgencyDetails = async () => {
    setLoading(true);
    const options = {
      method: 'GET',
      url: AGENCY_DETAILS_URL,
      headers: authHeader(),
      params: { agencyId: loggedAgency },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === 'Success') {
        setAgencyData(response.data);
        setChecked(response.data.agency.isNotify)
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    getAgencyDetails();
  }, []);

  const { agency = {} , } = agencyData;
  const {
    accountHolderName = '',
    accountNumber = '',
    agencyLogo = '',
    agencyAddress = '',
    agencyEmail = '',
    agencyPhone = '',
    bankAddress = '',
    companyName = '',
    createdDate = '',
    createdName = '',
    ifscCode = '',
    locationCodeId = '',
    taxId = '',
    verificationDocument = '',
  } = agency;


console.log(checked)

  const onChangeChecked = async(flag) =>{
  
  
const {locationCodeDetails = [] } = agencyData;
 
    setLoading(true);
    const options = {
      method: 'PUT',
      url: AGENCY_UPDATE,
      headers: authHeader(),
      data: { isNotify: flag , agencyId: loggedAgency, locationCodeDetails : locationCodeDetails },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === 'Success' ) {
        Swal.fire(getAlertToast("success",'Notification status updated'));
      }
      setChecked(flag);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }  
 
  }
  

  return (
    <Fragment>
      <Row>
        <Col md="2" />
        <Col md="8">
          <Card className="manageUpdate">
            <CardHeader>Agency Information </CardHeader>
            <CardBody className="details">
              <center>{loading && <CustomLoader loading={loading} />}</center>

              <div>
                <div className="imgUpload" style={{ marginBottom: '0.5rem' }}>
                  <img
                    className="uploadImg"
                    src={agencyLogo || defaultAvatar}
                    width={100}
                    height={100}
                  />
                </div>
                <center>
                  <span style={{ color: '#48465b', fontWeight: '700' }}>
                    Agency Logo
                  </span>
                </center>
                <div className='notifity'>
                  <span style={{ color: '#48465b', fontWeight: '700'}}>
                    Allow Email Notification
                  </span>
                &nbsp;
                 <Switch
                    className='react-swtich'
                    onChange={onChangeChecked}
                    checked={checked}
                    onColor="#86d3ff"
                    onHandleColor='#2693e6'
                    handleDiameter={20}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.6)'
                    height={15}
                    width={30}
                 />
                </div>
              </div>
              <div className="kt-widget__content">
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Agency Name :</span>
                  <span className="kt-widget__data">
                    {companyName || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Agency Email :</span>
                  <span className="kt-widget__data">
                    {agencyEmail || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">
                    Agency Phone Number :
                  </span>
                  <span className="kt-widget__data">
                    (+1) {agencyPhone || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Agency Address:</span>
                  <span className="kt-widget__data">
                    {agencyAddress || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Created Date :</span>
                  <span className="kt-widget__data">
                    {getDateString(createdDate) || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Created By :</span>
                  <span className="kt-widget__data">
                    {createdName || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Location Code ID :</span>
                  <span className="kt-widget__data">
                    {locationCodeId || 'N/A'}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">
                    Verification Document :
                  </span>
                  <span className="kt-widget__data">
                    <a href={verificationDocument} target="_blank">
                      <i
                        className="far fa-file"
                        style={{
                          marginLeft: '9px',
                          fontSize: '17px',
                          color: '#18bb0e',
                        }}
                      ></i>
                    </a>
                  </span>
                </div>
                {!!(role === 'Merchant Admin') && (
                  <Fragment>
                    <div className="kt-widget__info mb-2">
                      <span className="kt-widget__label">
                        Account Holder Name :
                      </span>
                      <span className="kt-widget__data">
                        {accountHolderName || 'N/A'}
                      </span>
                    </div>
                    <div className="kt-widget__info mb-2">
                      <span className="kt-widget__label">
                        Account Number :{' '}
                      </span>
                      <span className="kt-widget__data">
                        {accountNumber || 'N/A'}
                      </span>
                    </div>
                    <div className="kt-widget__info mb-2">
                      <span className="kt-widget__label">Bank Address :</span>
                      <span className="kt-widget__data">
                        {bankAddress || 'N/A'}
                      </span>
                    </div>
                    <div className="kt-widget__info mb-2">
                      <span className="kt-widget__label">Routing Number :</span>
                      <span className="kt-widget__data">
                        {ifscCode || 'N/A'}
                      </span>
                    </div>
                    <div className="kt-widget__info mb-2">
                      <span className="kt-widget__label">Tax ID :</span>
                      <span className="kt-widget__data">{taxId || 'N/A'}</span>
                    </div>
                  </Fragment>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md="2" />
      </Row>
    </Fragment>
  );
};

export default AgencyProfile;
